module.exports = __webpack_public_path__ + "media/images/plans/propose_original/proposal-sumple-1-8fd44aa494d1d5437107c6d8a21631af.jpg";